import { createRef } from "react";
import { Tooltip, WrapperContainer } from "../components";

const withTooltip = (Component) => {
  // eslint-disable-next-line react/display-name, react/prop-types
  return ({ tooltipLabel, tooltipComponent, xShift, ...props }) => {
    const componentRef = createRef();

    return tooltipLabel || tooltipComponent ? (
      <WrapperContainer innerRef={componentRef}>
        <Component {...props} />
        {(tooltipLabel || tooltipComponent) && (
          <Tooltip
            childrenRef={componentRef}
            tooltipLabel={tooltipLabel}
            tooltipComponent={tooltipComponent}
            xShift={xShift}
          />
        )}
      </WrapperContainer>
    ) : (
      <Component {...props} />
    );
  };
};

export default withTooltip;
